import { render, staticRenderFns } from "./icon-arrow-quarternary.vue?vue&type=template&id=b464ca4e&scoped=true&"
import script from "./icon-arrow-quarternary.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b464ca4e",
  null
  
)

export default component.exports